import { makeAutoObservable, runInAction } from 'mobx';

import { cmApi } from '../../../api';
import { preloaderStore } from '../../preloaderStore';
import type { CmApi, CounterPartyTypeDto } from '../../../api';

type CounterpartyTypeDtoDefId = CounterPartyTypeDto & { code: string };

class CounterpartyTypesStore {
  counterpartyTypes: CounterpartyTypeDtoDefId[] = [];

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  fetch = async (): Promise<void> => {
    preloaderStore.preloader(true);
    try {
      const { data } = await this.api.counterpartyTypes.getCounterPartyTypes();

      if (data) {
        runInAction(() => {
          this.counterpartyTypes = data?.map((type) => ({ ...type, code: type.code ?? '' })) ?? [];
        });
      }
    } catch (error) {
      console.error(error);
    }
    preloaderStore.preloader(false);
  };
}

export const counterpartyTypesStore = new CounterpartyTypesStore({ api: cmApi });
